import { useEffect, useRef } from "react"

export const useDidMount = (fnc: () => void) => {
  const init = useRef<boolean>(false);
  return useEffect(() => {
    if (init.current) return;
    init.current = true;
    fnc();
  }, []);
}